import type { FlavorConfig } from '@/types/flavor';

/**
 * Sideconvo PRODUCTION Environment Configuration
 */
const config: FlavorConfig = {
  name: 'sideconvo',
  environment: 'prod',
  appTitle: 'Lead Management | Sideconvo.ai',
  firestoreDB: 'lead-management',
  demoSiteBaseUrl: 'https://client.sideconvo.ai',
  snapshotBucket: 'snapshot-sideconvo',
};

export default config;
